import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.Drawer.Invitations', {
    invitedBy: '{user} invited you to join',
    declineAction: 'Decline',
    acceptAction: 'Accept invitation',
});
